import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { TableWrap } from '../../Wrap/PaymentDuductionWrap'

import DailyTableHeader from './PaymentDuductionHeader'
import DailyTableBody from './PaymentDuductionTableBody'

const PaymentDuductionTable = ({
    register, getValues, setValue, watch, reset, errors,
    defaultUrl, workInfoList, selectedIndex, selectFunction,workDivisions,
    passDivisions,
    transportationPublic,
    transportationPraivate,
    gasCost
  }) => {

  return (
    <TableWrap visible={workInfoList.length ? true : false}>
      <DailyTableHeader/>
      <DailyTableBody
        register={register}
        getValues={getValues}
        setValue={setValue}
        watch={watch}
        reset={reset}
        errors={errors}
        workDivisions={workDivisions}
        defaultUrl={defaultUrl}
        workInfoList={workInfoList}
        passDivisions={passDivisions}
        transportationPublic={transportationPublic}
        transportationPraivate={transportationPraivate}
        gasCost={gasCost}
      >
      </DailyTableBody>
    </TableWrap>
  )
}

PaymentDuductionTable.propTypes = {
  register: PropTypes.func,
  getValues: PropTypes.func,
  setValue: PropTypes.func,
  watch: PropTypes.func,
  reset: PropTypes.func,
  errors: PropTypes.object,

  defaultUrl: PropTypes.string,
  workInfoList: PropTypes.array,
  selectedIndex: PropTypes.any,
  selectFunction: PropTypes.func
}

export default PaymentDuductionTable
